<template>
  <div>
    <SectionHeader>
      <h1>
        Steam Account Transfer
      </h1>
    </SectionHeader>
    <div v-if="user.id !== userToBeTransfered.id">
      <grid horizontal="center" vertical="middle">
        <grid-item size="1/3">
          <h3 class="text-light">
            {{ userToBeTransfered.username }}
          </h3>
          <a
            :href="
              'http://steamcommunity.com/profiles/' +
                userToBeTransfered.steam_id
            "
            target="_blank"
            v-tooltip="'Steam Profile Page'"
          >
            <Icon
              type="steam"
              :rounded="true"
              backgroundColor="#75dd8f"
              borderColor="#4c4c4c"
            />
          </a>
        </grid-item>
        <grid-item style="display: flex">
          <Icon type="next-right" :size="3" />
        </grid-item>
        <grid-item size="1/3">
          <div v-if="isLoggedIn">
            <h3 class="text-light">{{ user.username }}</h3>
            <a
              :href="
                user.steam_id
                  ? 'http://steamcommunity.com/profiles/' + user.steam_id
                  : null
              "
              target="_blank"
              v-tooltip="{
                content: user.steam_id
                  ? 'Steam Profile Page'
                  : 'No Steam Account Connected'
              }"
            >
              <Icon
                type="steam"
                :rounded="true"
                :backgroundColor="user.steam_id ? '#75dd8f' : '#ce7a8d'"
                borderColor="#4c4c4c"
              />
            </a>
          </div>
          <div v-else>
            <DecoratedButton
              @click="login"
              class="wide short dark-blue"
              fontSize=".8em"
            >
              LOG IN
            </DecoratedButton>
          </div>
        </grid-item>
      </grid>
      <Divider />
      <DecoratedButton
        v-if="isLoggedIn && userToBeTransfered.id"
        :loading="transferLoading"
        @click="next"
      >
        CONTINUE
      </DecoratedButton>
    </div>
    <div v-else-if="user.id === userToBeTransfered.id">
      <Alert class="error">
        <Icon
          slot="icon"
          type="info"
          :size="2"
          padding=".5em"
          :rounded="true"
          backgroundColor="transparent"
        />
        <p>
          <b>Warning</b>
        </p>
        <p>
          You are logged in to the same account you want to transfer.
        </p>
      </Alert>
    </div>
    <DividerSeparator v-if="isLoggedIn">
      <DecoratedButton
        class="wide short dark-blue"
        fontSize=".8em"
        @click="logout"
      >
        LOGIN WITH A DIFFERENT ACCOUNT
      </DecoratedButton>
    </DividerSeparator>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import ThirdPartyLogin from "@/components/partials/auth/ThirdPartyLogin";
import Loader from "vue-spinner/src/BounceLoader";

export default {
  name: "form-transfer-confirm",
  components: { ThirdPartyLogin, Loader },
  data: function() {
    return {
      transferLoading: false
    };
  },
  props: {
    userToBeTransfered: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters("user", {
      user: "getUser",
      isLoggedIn: "isLoggedIn"
    })
  },
  methods: {
    initRedirect() {
      return this.services.AuthService.init({
        redirect_uri: this.$route.fullPath
      });
    },
    next() {
      this.transferLoading = true;
      setTimeout(() => {
        this.services.UserResource.transferSteamId({
          id: this.$route.params.id
        })
          .then(() => {
            this.$emit("continue");
          })
          .catch(e => {
            this.transferLoading = false;
          });
      }, 1000);
    },
    logout() {
      this.initRedirect().then(() => {
        this.services.AuthService.logoutRedirect();
      });
    },
    login() {
      this.initRedirect().then(() => {
        this.$router.push({ name: this.pages.AUTH_LOGIN });
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
